import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslations } from '@libs/translations';
import { Points } from '@styles';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { Container, PageTop } from '@components/Help-Center-Components';

import { HELP_CENTER } from '@constants';
import { ArticleCard } from '@components/Help-Center-Components/article-card';

export const LearningSection = ({ data }) => {
  const { locale } = useSelector((state) => state.settings);
  const translations = useTranslations();
  const links = [
    {
      href: `/${HELP_CENTER.MAIN}`,
      name: translations.t('site.help.title'),
    },
    {
      href: '',
      name: `${data.caption}`,
    },
  ];

  return (
    <Wrapper>
      <BreadcrumbsWrapper>
        <Breadcrumbs links={links} />
      </BreadcrumbsWrapper>
      <Container>
        <PageTop title={data.caption} description={data.description} />
        <CardsWrap>
          {data.items?.map((item) => (
            <ArticleCard locale={locale} key={item.id} {...item} sectionUrl={data.slug} isFixedHeight={true} />
          ))}
        </CardsWrap>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 55px 16px 0;
  width: calc(100vw - 32px);
  overflow: auto;

  @media ${Points.tablet_landscape} {
    margin: 30px 28px 0;
    width: calc(100% - 46px);
  }

  @media ${Points.laptop_wide} {
    margin: 40px auto 0;
    width: 1280px;
  }

  @media ${Points.fullhd} {
    margin: 40px auto 0;
    width: 1386px;
  }
`;

const BreadcrumbsWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-bottom: 16px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    overflow: visible;
  }
`;

const CardsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 340px;
  margin: 60px auto 0;

  @media ${Points.tablet_portrait} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 696px;
  }

  @media ${Points.tablet_landscape} {
    grid-template-columns: repeat(3, 1fr);
    width: 966px;
    margin: 70px auto 0;
  }

  @media ${Points.laptop_wide} {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    width: 1280px;
    margin: 80px auto 0;
  }

  @media ${Points.fullhd} {
    width: 1380px;
    margin: 90px auto 0;
  }
`;
